import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Heading from "../../elements/heading";
import PrimaryLink from "../../elements/primary-link";
import MyAccountTemplate from "../../sections/my-account-template";
import AccountOverviewForm from "../../sections/account-overview-form";
import BodyText from "../../elements/body-text";
import MembershipOverview from "../../elements/membership-overview";
import { connect } from "react-redux";
import Image from "../../elements/image";
import api from "../../utils/api";
import { selectUserState, staffInfoSelector } from "../../selectors/application";
import { genrateHeadingWithFirstName } from "../../utils/myAccount";
import GearOrderItem from "../../sections/gear-order-item";
import OverviewPromoFinalizeOrder from "../../sections/overview-promo-finalize-order";
import OverviewPromoAppDownload from "../../sections/overview-promo-app-download";
import { getUserInfo } from "../../services/userService";
import { S_LANG, S_USER, webStorage } from "../../utils/webStorage";
import { setUserInfoAction } from "../../redux/actions";
import { generateReactKey } from "../../utils/reactKey";
import { getDictionary, isLoggedIn } from "../../services/siteService";
import { isEmptyObj } from "../../utils/siteUtils";
import { dictTypes, ProductType, orderTypes, orderDetailsStatus } from "../../utils/lynkco-constants";
import { getGearOrderFieldValue, getOrderFieldValue, getGearOrderDetailValue, getPdpOrderFieldValue, getPdpOrderDetailValue } from "../../utils/processesOrderDetails";
import storeApi from "../../utils/storeApi";
import { useParams } from "react-router-dom";
import getSiteInfo from "../../utils/getSiteInfo";
import { checkIfAnyFirmOrder } from "../../utils/finalizeOrderUtils";
import { getLang, getOrderType } from "../../utils/processesOrderDetails";
import "./style.scss";

const MyAccountOverview = ({ rendering, page, fields, user, staffInfo, setUserInfo, match }) => {
  const {
    hero,
    accountMenu,
    membershipTitleType,
    membershipTitleBody,
    personalInformationTitleType,
    personalInformationTitleBody,
    customerNumberLabel,
    firstNameLabel,
    lastNameLabel,
    editProfileButton,
    loginSettingsTitleType,
    loginSettingsTitleBody,
    emailLabel,
    passwordLabel,
    editLoginButton,
    latestOrderTitleType,
    latestOrderTitleBody,
    manageOrderAndPaymentButton,
    colabTitleType,
    colabTitleBody,
    colabBody,
    colabButton,
    membershipOverview,
    orderLabels,
    gearOrderLabels,
    gearOrderDetailLabels,
    pdpOrderLabels,
    appBackgroundImage,
    appDownloadHeadingType,
    appDownloadHeadingBody,
    qrCode,
    appLink,
    finalizeOrderHeadingType,
    finalizeOrderHeadingBody,
    finalizeOrderOverviewText,
    finalizeOrderOverviewBody,
    finalizeOrderButton,
    membershipDataConfig
  } = fields;

  const { loginLink } = page.fields;
  const params = useParams();
  const lang = webStorage.get(S_LANG);
  const [orderImage, setOrderImage] = useState({});
  const [orderNo, setOrderNo] = useState();
  const [orderId, setOrderId] = useState();
  const [latestOrderType, setLatestOrderType] = useState(null);
  const [latestOrderGears, setLatestOrderGears] = useState([]);
  const [formSections, setFormSections] = useState([]);
  const [membershipPrice, setMembershipPrice] = useState(null);
  const [membershipLevel, setMembershipLevel] = useState(null);
  const { membership0, membership1, membership2, membership3 } = membershipOverview[0].fields;
  const [showFinilizeOrder, setShowFinilizeOrder] = useState(false);
  const [membershipPlanCode, setMembeshipPlancode] = useState();
  const [orderLang, setOrderLang] = useState();
  const [orderMarket, setOrderMarket] = useState();
  const [orderOrgId, setOrderOrg] = useState();

  const latestOrder = {
    heading: {
      type: latestOrderTitleType,
      html: latestOrderTitleBody
    },
    items: [], // comes from e-commerce system or some order history system
    // I am unsure if the label should come from sitecore or e-commerce.
    button: manageOrderAndPaymentButton.fields
  };

  const appDownload = {
    backgroundImage: appBackgroundImage?.value?.src,
    heading: {
      typographyClass: "type-h3",
      type: appDownloadHeadingType,
      html: appDownloadHeadingBody
    },
    primaryLink: appLink?.fields,
    qrCode: {
      src: qrCode?.value?.src
    }
  };

  const finalizeOrder = {
    heading: {
      type: finalizeOrderHeadingType,
      html: finalizeOrderHeadingBody
    },
    overviewHeading: finalizeOrderOverviewText,
    overviewBody: finalizeOrderOverviewBody,
    button: finalizeOrderButton?.fields,
    membershipPlanCode: membershipPlanCode,
    orderLang,
    orderMarket,
    orderNo,
    orderOrgId,
    membershipCode: user.membershipCode
  };

  let membershipLabels = null;
  let delivermethods = null;

  useEffect(() => {
    if (!isLoggedIn()) {
      let loginUrl = loginLink.value.href;
      if (isEmptyObj(loginUrl)) {
        loginUrl = `/${lang}/login`;
      }
      global.location.href = `${loginUrl}?redirect=${encodeURIComponent(`/${lang}/${params.sitecoreRoute}`)}`;
    }
  }, []);

  useEffect(() => {
    init();
  }, [staffInfo]);

  useEffect(() => {
    async function checkFinalizeOrder() {
      const firmOrders = await checkIfAnyFirmOrder();
      if (!firmOrders?.length > 0) {
        checkIfPresalesOrderExists();
      }
    }

    checkFinalizeOrder();
  }, [orderId]);

  const init = async () => {
    const user = await getUserInfo();
    setUserInfo(user);
    webStorage.set(S_USER, user);
    const personalInformation = {
      heading: {
        type: personalInformationTitleType,
        html: personalInformationTitleBody
      },
      // get values from integration
      items: [
        { label: customerNumberLabel.value, value: user.customerNumber },
        { label: firstNameLabel.value, value: user.firstName },
        { label: lastNameLabel.value, value: user.lastName }
      ],
      button: {
        ...editProfileButton?.fields
      }
    };
    const loginSettings = {
      heading: {
        type: loginSettingsTitleType,
        html: loginSettingsTitleBody
      },
      items: [
        { label: emailLabel.value, value: user.email },
        { label: passwordLabel.value, value: "******" }
      ],
      button: editLoginButton && {
        link: editLoginButton.fields.link,
        colorScheme: editLoginButton.fields.colorScheme,
        iconName: editLoginButton.fields.iconName
      }
    };
    if (user?.membershipCode === membership0.fields.code.value) {
      setMembershipPrice(membership0.fields.price.value);
    } else if (user?.membershipCode === membership1.fields.code.value) {
      setMembershipPrice(membership1.fields.price.value);
    } else if (user?.membershipCode === membership2.fields.code.value) {
      setMembershipPrice(membership2.fields.price.value);
    } else if (user?.membershipCode === membership3.fields.code.value) {
      setMembershipPrice(membership3.fields.price.value);
    }
    await getLatestOrderDetail(personalInformation, loginSettings);
    await getMembershipLabels();
  };

  const getMembershipLabels = async () => {
    const res = await getDictionary(dictTypes.membership);
    setMembershipLevel(res.filter(x => x.dicCode === user?.membershipCode)[0]?.languages[getLang(lang)]?.dicName);
  };

  const getLatestOrderDetail = async (personalInformation, loginSettings) => {
    membershipLabels = await getDictionary(dictTypes.membership);
    delivermethods = await getDictionary(dictTypes.deliveryMethod);
    let res = {};
    if (staffInfo) {
      res = await storeApi.order.latest({ userAccount: user.userAccount });
    } else {
      res = await api.order.latest.index();
    }

    if (res.obj == null) {
      setFormSections([personalInformation, loginSettings]);
      return null;
    }

    let orderType = getOrderType(res.obj?.subType);

    let orderItems = res.obj?.suborders[0]?.orderItems;
    let firstOrder = orderItems ? orderItems[0] : "";
    let suborders = res?.obj?.suborders ? res?.obj?.suborders : [];
    const siteInfo = await getSiteInfo();
    // Gears Order
    if (orderType === "gears") {
      let _items = gearOrderLabels.map(x => ({
        label: x.fields?.phrase?.value,
        value: getGearOrderFieldValue(x.fields?.key?.value, res.obj, lang, delivermethods, siteInfo.dateFormat)
      }));
      let gearProductDataIndex = _items?.findIndex(x => x.value === "html");
      _items[gearProductDataIndex] = {
        label: "gearProductData",
        value: "html",
        type: "GearOrders",
        orderItems: getGearOrderDetailValue({ detailsItem: gearOrderDetailLabels, res: res.obj })
      };
      setLatestOrderGears(_items);
    } else if (orderType === "presale") {
      // PreSales Order
      let _items = orderLabels.map(x => ({
        label: x.fields?.phrase?.value,
        value: getOrderFieldValue(x.fields?.key?.value, res.obj, lang, membershipLabels, siteInfo.dateFormat)
      }));
      latestOrder.items = _items;
      setOrderImage({
        src: firstOrder?.image
      });
      setOrderId(res?.obj?.id);
    } else if (orderType) {
      let _items = (pdpOrderLabels || []).map(x => ({
        label: x.fields?.phrase?.value,
        value: getPdpOrderFieldValue(x.fields?.key?.value, res.obj, lang, null, siteInfo.dateFormat, membershipLabels)
      }));
      let orderImageNew = null;
      suborders.map(suborder => {
        suborder.orderItems.map(orderItem => {
          if (orderItem?.productType === ProductType.vehicle) {
            orderImageNew = { src: orderItem?.image };
          }
          return null;
        });
        return null;
      });
      latestOrder.items = _items;
      if (orderImageNew) {
        setOrderImage(orderImageNew);
      }
    }

    setFormSections([personalInformation, loginSettings, latestOrder]);
    setLatestOrderType(orderType);
  };
  const checkIfPresalesOrderExists = async () => {
    let presalesOrder;

    if (orderId === undefined) {
      const { obj } = await api.order.latest.specify(null, {
        subType: orderTypes?.presales,
        orderStatus: [orderDetailsStatus?.close]
      });
      presalesOrder = obj;
    } else {
      const { obj } = await api.order.detail(null, {
        id: orderId
      });
      presalesOrder = obj;
    }

    if ((presalesOrder?.orderStatusCode == "ORDERSTATUSTOC03" && presalesOrder?.isPresaleFinalized === "0") || user?.membershipCode === "MEMBERSHIP02") {
      if (presalesOrder) {
        setMembeshipPlancode(membershipDataConfig?.fields?.bacMembershipTypeId?.fields?.phrase?.value);
      } else if (user?.membershipCode === "MEMBERSHIP02") {
        setMembeshipPlancode(membershipDataConfig?.fields?.m2mMembershipTypeId?.fields?.phrase?.value);
      } else {
        return;
      }

      setOrderLang(presalesOrder?.language || user?.preferredLanguage?.toLowerCase());
      setOrderMarket(user?.preferredCountryCode?.toLowerCase());
      setOrderOrg(presalesOrder?.orgId);
      setOrderNo(presalesOrder?.orderNo);

      setShowFinilizeOrder(true);
    }
  };

  const renderComplexOrderItem = item => {
    switch (item.type) {
      case "GearOrders":
        return (
          <div className="order-row--gear" key={generateReactKey()}>
            {item.orderItems.map(gear => (
              <GearOrderItem {...gear} key={generateReactKey()} />
            ))}
          </div>
        );
      default:
        return null;
    }
  };
  const noPreOrderDetail = () => {
    latestOrderGears &&
      latestOrderGears.length > 0 &&
      latestOrderGears.map(item => {
        const { label, value } = item;
        return value === "html" ? (
          renderComplexOrderItem(item)
        ) : (
          <div className="order-row" key={label + value}>
            <div className="label">{label}</div>
            <div
              className="value"
              dangerouslySetInnerHTML={{
                __html: value
              }}
            />
          </div>
        );
      });
  };
  return (
    <div className="my-account-overview-page" datasourceid={rendering.dataSource}>
      <MyAccountTemplate
        heroConfiguration={{
          ...hero[0].fields,
          titleBody: genrateHeadingWithFirstName(hero[0]?.fields?.titleBody, user?.firstName)
        }}
        menu={accountMenu[0].fields}
        page={rendering.page}
      >
        <div className="my-account-overview-page-form">
          {!showFinilizeOrder && user?.membershipCode !== "MEMBERSHIP02" && (
            <MembershipOverview
              {...{
                titleType: membershipTitleType,
                titleBody: membershipTitleBody,
                overview: {
                  headingType: membershipOverview[0].fields.titleType,
                  heading: membershipOverview[0].fields.title,
                  // update with values from integration
                  body: membershipLevel,
                  membershipFee: membershipPrice,
                  currency: ""
                },
                match: match,
                link: membershipOverview[0].fields.changeDetails
              }}
            />
          )}

          {showFinilizeOrder && <OverviewPromoFinalizeOrder {...finalizeOrder} />}

          {appDownload && <OverviewPromoAppDownload {...appDownload} />}
          {formSections.length > 0 && <AccountOverviewForm formSections={formSections} />}
          {latestOrderType === "gears" && (
            <>
              {noPreOrderDetail()}
              <PrimaryLink {...manageOrderAndPaymentButton.fields} />
            </>
          )}
        </div>

        {latestOrderType !== "gears" && orderImage?.src && <Image className="my-account-overview-page-car-image no-hover" {...orderImage} />}
        <div className="my-account-overview-page-bottom-panel">
          <Heading type={colabTitleType} html={colabTitleBody} typographyClass="type-h3" />

          <BodyText html={colabBody.value} />
          <PrimaryLink {...colabButton.fields} />
        </div>
      </MyAccountTemplate>
    </div>
  );
};

MyAccountOverview.propTypes = {
  rendering: PropTypes.shape({ dataSource: PropTypes.string }),
  fields: PropTypes.shape({
    // hero: PropTypes.object,
    accountMenu: PropTypes.array,
    membershipTitleType: PropTypes.object,
    membershipTitleBody: PropTypes.object,
    personalInformationTitleType: PropTypes.object,
    personalInformationTitleBody: PropTypes.object,
    customerNumberLabel: PropTypes.shape({ value: PropTypes.string }),
    firstNameLabel: PropTypes.shape({ value: PropTypes.string }),
    lastNameLabel: PropTypes.shape({ value: PropTypes.string }),
    editProfileButton: PropTypes.object,
    loginSettingsTitleType: PropTypes.object,
    loginSettingsTitleBody: PropTypes.object,
    emailLabel: PropTypes.shape({ value: PropTypes.string }),
    passwordLabel: PropTypes.shape({ value: PropTypes.string }),
    editLoginButton: PropTypes.shape({ value: PropTypes.string }),
    latestOrderTitleType: PropTypes.object,
    latestOrderTitleBody: PropTypes.object,
    manageOrderAndPaymentButton: PropTypes.object,
    colabTitleType: PropTypes.object,
    colabTitleBody: PropTypes.object,
    colabBody: PropTypes.shape({ value: PropTypes.string }),
    colabButton: PropTypes.object,
    membershipOverview: PropTypes.array
  })
};
const mapStateToProps = state => ({
  user: selectUserState(state),
  staffInfo: staffInfoSelector(state)
});
const mapDispatchToProps = dispatch => ({
  setUserInfo: data => dispatch(setUserInfoAction(data))
});
export default connect(mapStateToProps, mapDispatchToProps)(MyAccountOverview);
